import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import { productReducer } from './reducer/product';
import { cartReducer } from './reducer/cart';
import { orderReducer } from './reducer/order';
import promoReducer from './promoSlice';  // Import promo slice
import loadingReducer from './loadingSlice';
import chatReducer from "./chatSlice";
import restaurantReducer from './restaurantSlice.js';

// Configure the store with the reducers
export const store = configureStore({
  reducer: {
    user: userReducer,
    chat: chatReducer,
    products: productReducer,
    cart: cartReducer,
    order: orderReducer, // Note: 'order' is the key used in the state
    loading: loadingReducer,
    promo: promoReducer,  
    restaurant: restaurantReducer,
  },
});
